import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ProgramsPage from "./pages/ProgramsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import BookingPage from "./pages/BookingPage";
import QuranPage from "./pages/QuranPage";
import SurahPage from "./pages/SurahPage";
import MaterialsPage from "./pages/MaterialsPage";
import AdminPage from "./pages/AdminPage";
import PrivacyPage from "./pages/PrivacyPage";
import PolicyPage from "./pages/PolicyPage";
import TajweedBookPage from "./pages/TajweedBookPage";
import NooraniaBookPage from "./pages/NooraniaBookPage";
import PlacementTestPage from "./pages/PlacementTestPage";
import StudentPortalPage from "./pages/StudentPortalPage";

import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <BrowserRouter>
          <div className="App min-h-screen flex flex-col" style={{ backgroundColor: 'var(--bg-primary)' }}>
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/programs" element={<ProgramsPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/quran" element={<QuranPage />} />
                <Route path="/quran/:number" element={<SurahPage />} />
                <Route path="/materials" element={<MaterialsPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/policy" element={<PolicyPage />} />
                <Route path="/tajweed-bok" element={<TajweedBookPage />} />
                <Route path="/noorania-bok" element={<NooraniaBookPage />} />
                <Route path="/placement-test/:token" element={<PlacementTestPage />} />
                <Route path="/portal/:token" element={<StudentPortalPage />} />

                <Route path="/contact" element={<ContactPage />} />
                <Route path="/booking" element={<BookingPage />} />
              </Routes>
            </main>
            <Footer />
            <WhatsAppButton />
          </div>
        </BrowserRouter>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
